import React, { Component } from 'react';

import './fate-brings-you.css'

const COLORS = [
    null, 'var(--deep)', 'var(--stem)', 'var(--hex)', 'var(--dread)', 'var(--honored)', 'var(--seed)'
];

// Dice overlays (FateDieOverlay, RandomActionDieOverlay) flip
// window.__dieRolling on mount + dispatch 'die-roll-started', then
// clear the flag + dispatch 'die-settled' on dismiss. The EventRouter
// also exposes __eventRouterHasPendingDice so we can detect dice events
// that have been received but not yet processed (typical when the
// gamePlayerData update arrives before the queued event drains).
const DIE_SETTLED_EVENT = 'die-settled';
const DIE_ROLL_STARTED_EVENT = 'die-roll-started';
// Initial grace just covers the gap between the gamePlayerData update
// landing and the dice overlay's die-roll-started dispatch. Paired
// with the AI auto-tap (CC_DICE_NONROLLER_SMOOTH piece 1), the dice
// now tumble within ~200ms of overlay mount, so a 3000ms buffer was
// overkill — 500ms is enough for die-roll-started to register on the
// slow path. REVEAL_WATCHDOG_MS still catches the case where no dice
// event ever arrives.
const INITIAL_GRACE_MS = 500;
// After a settle, a follow-up die in a sequence (Random Action Die →
// Fate Die for the resulting action's juice) needs to register itself.
// 600ms originally; compressed to 100ms now that the auto-tap path
// makes the gap between settle and the next die's die-roll-started
// dispatch tight and predictable.
const POST_SETTLE_GRACE_MS = 100;
const REVEAL_WATCHDOG_MS = 12000;


function diceInFlight() {
    if (window.__dieRolling) return true;
    if (typeof window.__eventRouterHasPendingDice === 'function') {
        try {
            return !!window.__eventRouterHasPendingDice();
        } catch (err) {  // eslint-disable-line no-unused-vars
            return false;
        }
    }
    return false;
}


export class FateBringsYou extends Component {
    constructor(props) {
        super(props);
        this.state = { revealed: false };
        this.revealTimer = null;
        this.watchdogTimer = null;
    }

    componentDidMount() {
        window.addEventListener(DIE_SETTLED_EVENT, this.onDieSettled);
        window.addEventListener(DIE_ROLL_STARTED_EVENT, this.onDieRollStarted);
        this.scheduleReveal(INITIAL_GRACE_MS);
        this.watchdogTimer = setTimeout(this.reveal, REVEAL_WATCHDOG_MS);
    }

    componentWillUnmount() {
        this.cleanup();
    }

    cleanup = () => {
        window.removeEventListener(DIE_SETTLED_EVENT, this.onDieSettled);
        window.removeEventListener(
            DIE_ROLL_STARTED_EVENT, this.onDieRollStarted);
        if (this.revealTimer) {
            clearTimeout(this.revealTimer);
            this.revealTimer = null;
        }
        if (this.watchdogTimer) {
            clearTimeout(this.watchdogTimer);
            this.watchdogTimer = null;
        }
    }

    scheduleReveal = (ms) => {
        if (this.revealTimer) clearTimeout(this.revealTimer);
        this.revealTimer = setTimeout(this.maybeReveal, ms);
    }

    maybeReveal = () => {
        this.revealTimer = null;
        if (this.state.revealed) return;
        // If any dice are rolling or queued, defer. die-roll-started or
        // die-settled will re-trigger us.
        if (diceInFlight()) return;
        this.reveal();
    }

    onDieSettled = () => {
        // A die just dismissed. Try to reveal, but give a follow-up
        // roll a chance to register first.
        this.scheduleReveal(POST_SETTLE_GRACE_MS);
    }

    onDieRollStarted = () => {
        // A new die is about to roll — cancel any pending reveal so
        // we don't leak between back-to-back rolls.
        if (this.revealTimer) {
            clearTimeout(this.revealTimer);
            this.revealTimer = null;
        }
    }

    reveal = () => {
        if (this.state.revealed) return;
        this.cleanup();
        this.setState({ revealed: true });
    }

    render() {
        const color = COLORS[this.props.factionId];
        if (!this.state.revealed) {
            return <div className={'fate-brings-you'} aria-hidden={true}/>;
        }
        return <div className={'fate-brings-you'}>
            <div className={'fate-brings-you-text'} style={{color: color}}>
                Fate brings you {this.props.currentFate}{this.props.type && <>&nbsp;{this.props.type}</>}.
            </div>
        </div>;
    }
}
